// extracted by mini-css-extract-plugin
module.exports = {"card":"Avatar_card__1p5LD","circle":"Avatar_circle__1NTNb","image":"Avatar_image__2mBdo","name":"Avatar_name__1ed2b","history":"Avatar_history__2eTpN"};